import {
    all, call, put, takeLatest,
} from 'redux-saga/effects';
import { SearchQuery } from 'common/store/common/search/types';
import commonSearchQueryBuilder from 'common/services/search/commonSearchQueryBuilder';
import commonApiService from 'common/services/api/commonApiService';
import { SearchFilters } from 'common/services/commonEventsQueryBuilder';
import { TypeKeys, contentItemVersionsDataLoaded } from './actions';
import { VERSION_INDEX } from '../common';

export function* fetchVersionsData(action: any) {
    const filters: SearchFilters = {
        contentItemId: action.contentItemId,
    };

    const searchQuery: SearchQuery = commonSearchQueryBuilder.createQueryWithFilterAndSort(
        filters,
        'versionNumber',
        'desc',
        100,
    );

    const contentItemData = yield call(
        commonApiService.fetchListLiveData,
        VERSION_INDEX,
        encodeURIComponent(JSON.stringify(searchQuery))
    );

    yield put(contentItemVersionsDataLoaded(
        action.contentItemId,
        contentItemData.hits,
        false
    ));
}


function* watchFetchingContentItemVersionsData() {
    yield takeLatest(TypeKeys.FETCH_CONTENT_ITEM_VERSIONS_DATA, fetchVersionsData);
}


export function* rootVersionHistoryHeaderSaga() {
    yield all([
        watchFetchingContentItemVersionsData(),
    ]);
}
